module.exports = __webpack_public_path__ + "img/thumb_20.c6fde305.jpg";